<script>
import { Component, Vue, Prop } from "vue-property-decorator";
import orderPrint from "src/pages/components/order-manual/modules/orderPrint/index.vue";
import { foramtPrintInfo } from "src/pages/components/order-manual/modules/orderPrint/config.js";
import _ from 'lodash'
@Component({
  name: "order-manual",
  components: { orderPrint }
})
export default class App extends Vue {
  list = [];
  colMap = {
    '6': 3
  }
  brand = '';
  mounted() {
    const { params } = this.$route.query;
    let _params = JSON.parse(params);
    this.brand = _params.brand;
    _params.materialCodeList = _params && _params.materialCode ? _params.materialCode.split(',') : null
    this.$apis.autoAPi
      .POST_BOM_COSTCHECK_MANUAL_LIST(_params)
      .done(res => {
        const array = [];
        this.list = foramtPrintInfo(res.data, this.colMap[this.brand] || 2);
        console.log('this.list: ', this.list);
        let printList = []
        _.each(this.list, itemList => {
          _.each(itemList, list => {
            printList.push([list])
          })
        })
        this.list = printList
      })
      .fail(err => {});
  }
  render(h) {
    return (
      <div class="order-manual-page__print">
        <el-row>
          {this.list.map((item, idx) => {
            return (
              <el-row class="order-manual-page__print-page">
                {item.map(inner => {
                  return (
                    <div>
                      <el-row
                        class="order-manual-page__print-row"
                      >
                        <order-print info={inner} brand={this.brand}></order-print>
                      </el-row>
                      <div class="paginaton">第{idx + 1}页, 共{this.list.length}页</div>
                    </div>
                  );
                })}
              </el-row>
            );
          })}
        </el-row>
      </div>
    );
  }
}
</script>

<style lang="scss" scoped>
@media print {
  .order-manual-page__print-row {
    page-break-inside: avoid !important;
    page-break-before: unset !important;
    margin-bottom: 0mm;
  }
}
.order-manual-page__print-row {
  width: 190mm;
  height: 277mm;
  page-break-inside: avoid !important;
    page-break-before: unset !important;
}
.paginaton {
  width: 190mm;
  padding-bottom: 5px;
  text-align: right;
  padding-right: 5px;
}
</style>